import { MatLabelTooltipDirective } from './shared/directives/mat-label-tooltip.directive';
import { TooltipComponent } from './shared/components/tooltip/tooltip.component';
import { OrderedListDragDropPopupComponent } from './shared/components/ordered-list-drag-drop-popup/ordered-list-drag-drop-popup.component';
import { OrderedListDragDropComponent } from './shared/components/ordered-list-drag-drop/ordered-list-drag-drop.component';
import { SharedModule } from './shared/modules/shared/shared.module';
import { BooleanDropdownControlComponent } from './boolean-dropdown-control/boolean-dropdown-control.component';
import { DynamicListComponent } from './dynamic-list/dynamic-list.component';
import { InputControlComponent } from './input-control/input-control.component';
import { CheckboxControlComponent } from './checkbox-control/checkbox-control.component';
import { DropdownControlComponent } from './dropdown-control/dropdown-control.component';
import { CsvComponent } from './csv/csv.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JsonDynamicFormComponent } from './json-dynamic-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from './angular-material.module';
import { DynamicDictComponent } from './dynamic-dict/dynamic-dict.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { DynamicListDragDropComponent } from './dynamic-list-drag-drop/dynamic-list-drag-drop.component';
import { RadioControlComponent } from './radio-control/radio-control.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AddNewDialogComponent } from './add-new-dialog/add-new-dialog.component';
import { ConfirmDialogComponent } from './shared/components/confirm-dialog/confirm-dialog.component';
import { CsvUtilsComponent } from './csv-utils/csv-utils.component';
import { ChipControlComponent } from './chip-control/chip-control.component';
import { DataViewComponent } from './shared/components/data-view/data-view.component';
import { SearchBarFieldComponent } from './shared/components/search-bar-field/search-bar-field.component';
import { provideNgxMask, NgxMaskDirective } from 'ngx-mask';

@NgModule({
  imports: [
    CommonModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    NgxMatSelectSearchModule,
    MatProgressBarModule,
    NgxMaskDirective,
  ],
  declarations: [
    JsonDynamicFormComponent,
    CsvComponent,
    DropdownControlComponent,
    CheckboxControlComponent,
    InputControlComponent,
    DynamicListComponent,
    DynamicDictComponent,
    BooleanDropdownControlComponent,
    OrderedListDragDropComponent,
    OrderedListDragDropPopupComponent,
    TooltipComponent,
    MatLabelTooltipDirective,
    DynamicListDragDropComponent,
    RadioControlComponent,
    AddNewDialogComponent,
    ConfirmDialogComponent,
    CsvUtilsComponent,
    DataViewComponent,
    ChipControlComponent,
    SearchBarFieldComponent,
  ],
  exports: [
    JsonDynamicFormComponent,
    // Exported so a host can lay out fields the JSON config cannot express
    // with the form's own controls.
    CheckboxControlComponent,
    DropdownControlComponent,
    InputControlComponent,
    TooltipComponent,
    DataViewComponent,
    SearchBarFieldComponent,
  ],
  providers: [provideNgxMask()],
})
export class JsonDynamicFormModule {}
